<template>
<div class="card">
  <div class="img" :style="bgImg">
  </div>
  <div class="card_footer">
    <h3><slot></slot></h3>
    <Button @click.native="openProject">Details</Button>
  </div>
</div>
</template>

<script>
import Button from '../Button';

export default {
  name: 'Card',
  components: {
    Button,
  },
  props: ['imgURL', 'modalData'],
  computed: {
    bgImg() {
      return {
        backgroundImage: `url('${this.imgURL}')`,
      };
    },
  },
  methods: {
    openProject() {
      this.$store.commit('openModal', {
        title: this.modalData.title,
        icon: this.modalData.icon,
        body: this.modalData.body,
        footer: (this.modalData.footer) ? this.modalData.footer : [],
      });
    },
  },
};
</script>

<style lang="scss">
.card {
  max-width: 210px;
  background: $dark_bg;
  box-shadow: 0 3px 6px rgba(#000, .35);
  padding: 5px;
  border-radius: 2px;
  margin: 0 auto;
  .img {
    display: block;
    max-width: 200px;
    max-height: 200px;
    height: 200px;
    overflow: hidden;
    position: relative;
    background-size: cover;
    background-position: center;
  }
  .card_footer {
    padding-top: 10px;
    text-align: center;
    h3 {
      margin: 0;
      font-weight: 400;
      color: #fff;
      margin-bottom: 10px;
      font-size: 16px;
      span {
        display: block;
        padding-top: 5px;
        color: $text_gray;
        &::before {
          content: '[';
        }
        &::after {
          content: ']';
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Projects/Card.vue